export class Interactor {
    public onReactivate?: { () };
    public onCameBackAfterLongTime?: { () };

    private lastReaction?: Date;
    private lastCheck?: Date;
    private pollingInterval?: number;
    private tresholdMs = 4500;
    private longCameBackTreshold = 1000 * 60 * 60 * 4; //4 hours

    constructor() {
        document.addEventListener(
            "visibilitychange",
            () => {
                if (!document.hidden) this.fire();
            },
            false
        );

        document.addEventListener(
            "pageshow",
            () => {
                this.fire();
            },
            false
        );

        this.longpollInteraction();
    }

    private fire() {
        const now = new Date();

        const reactionDif = this.lastReaction !== undefined ? now.getTime() - this.lastReaction.getTime() : undefined;
        let dif = this.lastCheck !== undefined ? now.getTime() - this.lastCheck.getTime() : undefined;
        if (dif === undefined || (reactionDif !== undefined && reactionDif < dif)) dif = reactionDif;

        if (dif !== undefined && dif < this.tresholdMs) return;

        this.lastReaction = new Date();
        if (dif! > this.longCameBackTreshold) {
            if (this.onCameBackAfterLongTime !== undefined) this.onCameBackAfterLongTime();
        } else {
            if (this.onReactivate !== undefined) this.onReactivate();
        }
    }

    private longpollInteraction() {
        if (this.pollingInterval !== undefined) clearInterval(this.pollingInterval);

        this.pollingInterval = window.setInterval(() => {
            const now = new Date();
            if (this.lastCheck === undefined) {
                this.lastCheck = now;
                return;
            }

            if (now.getTime() - this.lastCheck.getTime() > this.tresholdMs) {
                this.longpollInteraction();
                this.lastCheck = undefined;

                setTimeout(() => this.fire(), 0);

                return;
            }

            this.lastCheck = now;
        }, 2000);
    }
}
